import { ReactComponent as Logo } from '../../assets/icons/briefcase.svg'

const Briefcase = () => {
    return (
        <Logo
            width={15}
            height={15}
            fill='white'
            style={{ marginRight: '5px' }}
        />
    )
}

export default Briefcase
